import Excel from 'exceljs';
import XLSX from "xlsx";

const creator = "Makenai";
const sheetName = "test";
const rowInicioTabla = 4;
const rowTitulo = 2;

const maxAnchuraColumna = 18;
const colorFondoHeader = 'FF67acd6';
const colorFuenteHeader = 'FF4d4c4a';
const colorFuente = "FF303030";
const stripped = true;
const colorFondoStripped = 'FFd8e5ed';
const colorFuenteStripped = "FF303030";

const colorFondoGanador = 'FFc9c899';
const colorFondoDesistido = "FFb4db65";

export function exportToExcel(tableJson, fields, filename) {

    let workbook = new Excel.Workbook();

    //crea la hoja de calculo
    workbook.creator = creator;
    let sheet = workbook.addWorksheet(sheetName);

    //añade un titulo a la tablña
    let rowTituloCell = sheet.getRow(rowTitulo).getCell(1);
    rowTituloCell.value = filename;
    rowTituloCell.font = {
        name: 'Calibri',
        color: { argb: colorFuenteHeader },
        family: 2,
        size: 18,
        bold: true
    };

    //anchura de cada columna
    let anchuraColumna = Object.keys(tableJson[0]).length < 12 ? maxAnchuraColumna + 6 : maxAnchuraColumna;

    
    //lista de campos a mostrar en la cabecera de la tabla
    let header = [];
    //quitamos la informacion que tenga que ver con acciones
    fields=fields.filter(field => field.key != "acciones");
   
    if (fields.length > 0) { //si hay una lista de campos la recorre y la añade a la cabecera       
        fields.forEach((field, index) => {
                  
            if (field.key != "acciones"){               
                header.push(field.label); //añade el nombre del campo
            }            
        })
    } else header = Object.keys(tableJson[0]);

    sheet.getRow(rowInicioTabla).values = header;

    let row = sheet.getRow(rowInicioTabla);

    //Estilo y formato de la cabecera de la tabla
    for (let i = 0; i < row.actualCellCount; i++) {
        row.getCell(i + 1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: colorFondoHeader },
            bgColor: { argb: 'ffcfc67a' },
        };
        row.getCell(i + 1).font = {
            name: 'Calibri',
            color: { argb: colorFuenteHeader },
            family: 2,
            size: 11,
            bold: true
        };
        sheet.getColumn(i + 1).width = anchuraColumna;
        row.getCell(i + 1).alignment = { wrapText: true, vertical: 'middle', horizontal: 'left' };
    }
    row.commit();

    //tableJson es la lista de elementos de la tabla
    //Estilo, formato y valores de las filas y columnas
    for (let j = 0; j < tableJson.length; j++) {
        let newRow = sheet.getRow(j + rowInicioTabla + 1);

        for (let i = 0; i < header.length; i++) {
            if (fields)
                newRow.getCell(i + 1).value = tableJson[j][fields[i].key];
            else
                newRow.getCell(i + 1).value = tableJson[j][Object.keys(tableJson[0])[i]];

            newRow.getCell(i + 1).alignment = { wrapText: true, vertical: 'middle', horizontal: 'left' };

            //estilo de las filas
            if (j % 2 != 0 && stripped)
                newRow.getCell(i + 1).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: colorFondoStripped },
                    bgColor: { argb: 'ffd1d1d1' }
                };

            newRow.getCell(i + 1).font = {
                name: 'Calibri',
                color: { argb: stripped ? colorFuenteStripped : colorFuente },
                family: 2,
                size: 11
            };

        }
        newRow.commit();
    }

    descargarExcel(workbook, filename);

}

export function generarInformeExcel(tableJson, fields, filename) {

     
    let workbook = new Excel.Workbook();

    //crea la hoja de calculo
    workbook.creator = creator;
    let sheet = workbook.addWorksheet(sheetName);

    //añade un titulo a la tablña
    let rowTituloCell = sheet.getRow(rowTitulo).getCell(1);
    rowTituloCell.value = filename;
    rowTituloCell.font = {
        name: 'Calibri',
        color: { argb: colorFuenteHeader },
        family: 2,
        size: 18,
        bold: true
    };

    //anchura de cada columna
    let anchuraColumna = Object.keys(tableJson[0]).length < 12 ? maxAnchuraColumna + 6 : maxAnchuraColumna + 1;

    //lista de campos a mostrar en la cabecera de la tabla
    let header = [];
    if (fields.length > 0) { //si hay una lista de campos la recorre y la añade a la cabecera
        fields.forEach((field, index) => {
            if (field.key != "acciones")
                header.push(field.label); //añade el nombre del campo
            else fields.splice(index, 1);
        })
    } else header = Object.keys(tableJson[0]);

    sheet.getRow(rowInicioTabla).values = header;

    let row = sheet.getRow(rowInicioTabla);

    //Estilo y formato de la cabecera de la tabla
    for (let i = 0; i < row.actualCellCount; i++) {
        row.getCell(i + 1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: colorFondoHeader },
            bgColor: { argb: 'ffcfc67a' },
        };
        row.getCell(i + 1).font = {
            name: 'Calibri',
            color: { argb: colorFuenteHeader },
            family: 2,
            size: 11,
            bold: true
        };
        sheet.getColumn(i + 1).width = anchuraColumna;
        row.getCell(i + 1).alignment = { wrapText: true, vertical: 'middle', horizontal: 'left' };
    }
    row.commit();

    //tableJson es la lista de elementos de la tabla
    //Estilo, formato y valores de las filas y columnas
    let currentLote;
    let newRow;
    let inicioFila = rowInicioTabla;
    let desistido; //si un lote esta desierto o desistido
    let loteDesistido = -1; //numero del lote que esta desierto o desistido
    let contadorFila = 0; //numero de fila en la que se insertan datos

    for (let j = 0; j < tableJson.length; j++) {
        
        if(desistido && currentLote == tableJson[j].numeroLote){
            continue;
        }
        if (currentLote != tableJson[j].numeroLote) {
            newRow = sheet.getRow(contadorFila + inicioFila + 2);
            contadorFila++;
            desistido = false;
            currentLote = tableJson[j].numeroLote;
            if (tableJson[j].estadoLote == "Desierto" || tableJson[j].estadoLote == "Desistido o renunciado") {
                desistido = true;
                if (loteDesistido != tableJson[j].numeroLote) {
                    loteDesistido = tableJson[j].numeroLote;
                    newRow.getCell(1).value = tableJson[j].numeroExpediente
                    newRow.getCell(2).value = "Lote " + tableJson[j].numeroLote + " - " + tableJson[j].estadoLote
                }
            }
            inicioFila++;
        } else {
            if (!desistido) {
                newRow = sheet.getRow(contadorFila + inicioFila + 1);
                contadorFila++;
            }
        }

        if (//tableJson[j].puestoConcurso == 1 || 
            tableJson[j].descripcionEstado == 'Adjudicado' || 
            tableJson[j].descripcionEstado == 'Asignado Pendiente Validar' 
            || desistido) {

            //estilo de las filas
            if (desistido)
                newRow.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: colorFondoDesistido },
                    bgColor: { argb: 'ffd1d1d1' }
                };
            else
                newRow.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: colorFondoGanador },
                    bgColor: { argb: 'ffd1d1d1' }
                };

            newRow.font = {
                name: 'Calibri',
                color: { argb: colorFuenteStripped },
                family: 2,
                size: 15
            };
        } else {
            //estilo de las filas
            newRow.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: colorFondoStripped },
                bgColor: { argb: 'ffd1d1d1' }
            };

            newRow.font = {
                name: 'Calibri',
                color: { argb: colorFuenteStripped },
                family: 2,
                size: 10
            };
        }
        
        if (!desistido)
            for (let i = 0; i < header.length; i++) {
                
                if (fields)
                    newRow.getCell(i + 1).value = tableJson[j][fields[i].key] + "";
                else
                    newRow.getCell(i + 1).value = tableJson[j][Object.keys(tableJson[0])[i]] + "";


                newRow.getCell(i + 1).alignment = { wrapText: true, vertical: 'middle', horizontal: 'left' };
            }

        newRow.commit();
    }

    descargarExcel(workbook, filename);

}

function descargarExcel(workbook, filename) {
   
    const buffer = workbook.xlsx.writeBuffer().then(res => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const blob = new Blob([res], { type: fileType });
        const a = document.createElement('a');
        a.setAttribute('download', filename + EXCEL_EXTENSION);
        a.setAttribute('href', window.URL.createObjectURL(blob));
        a.click();
    });


}